'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WelcomeMessageTooltip() {
  var title = _I18n2.default.text('conversationsUI.chat.welcomeMessageTooltip');

  return _react2.default.createElement(
    _UITooltip2.default,
    { title: title },
    _react2.default.createElement(
      'i',
      { className: 'welcome-message-link m-right-1' },
      _I18n2.default.text('conversationsUI.chat.welcomeMessage')
    )
  );
}

exports.default = WelcomeMessageTooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/WelcomeMessageTooltip.js
// module id = 1129
// module chunks = 2 3